import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ISearchResult, SearchConfig } from '../../interfaces/types';

const initialState: SearchConfig = (window as any).SearchConfig;

const searchConfigSlice = createSlice({
    name: 'search-config-slice',
    initialState,
    reducers: {
    },
})

export const { setSearchResults } = searchConfigSlice.actions;
export default searchConfigSlice.reducer;